import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscribable } from '../../components/base-component/subscribable';
import { PlatformBrowserService } from '../../services/platform-browser.service';
import { STORAGE } from '../../storages/storages.inject';

export interface ILang {
  code: string;
  name: string;
  culture: string;
}

export const LANG_LIST: ILang[] = [
  { code: 'fr', name: 'Français', culture: 'fr' },
  { code: 'en', name: 'English', culture: 'en' },
  { code: 'it', name: 'Italian', culture: 'it' },
  { code: 'ja', name: 'Japanese', culture: 'ja' },
  { code: 'zh-tw', name: 'Chinese', culture: 'zh-tw' },
  { code: 'zh', name: 'Simplified Chinese', culture: 'zh' },
  { code: 'ko', name: 'Korean', culture: 'ko' },
  { code: 'de', name: 'German', culture: 'de' },
];

@Injectable()
export class FavieTranslateService extends Subscribable {
  public static readonly LOCALE_STORAGE_KEY = 'LOCALE_STORAGE_KEY';

  constructor(
    @Inject(STORAGE)
    protected readonly storage: Storage,
    private readonly translateService: TranslateService,
    private readonly platformBrowserService: PlatformBrowserService,
  ) {
    super();
  }

  public switchLanguage(lang: string): void {
    this.translateService.setDefaultLang(lang);
  }

  public setDefaultLanguage() {
    let language = this.translateService.getBrowserLang();
    
    if (this.platformBrowserService.isPlatformBrowser) {
      language = language || window.navigator['userLanguage'] || window.navigator['language'];
    }

    const localStorage = this.storage.getItem(FavieTranslateService.LOCALE_STORAGE_KEY);
    if (localStorage) {
      language = localStorage;
    }
    const currentLang = LANG_LIST.map(x => x.code).indexOf(language) > -1 ? language : 'fr';
    this.translateService.setDefaultLang(currentLang);
  }

  public getLanguage() {
    return this.translateService.getDefaultLang();
  }
}
